import LeaveManagementComponent from '../LeaveManagementComponent.vue'

export default [
    {
        path: '/leave-management',
        name: 'LeaveManagement',
        meta: {
            layout: 'default',
            requiresAuth: true
            // Access is enforced by the component (canAccess -> "no access" card)
            // and the API (LeaveScopeTrait: 403 + per-manager data scoping).
            // Not a plain requiresRole because team managers (user_role_managers)
            // qualify without a manager role_id, and the router guard can't see
            // that relationship.
        },
        component: LeaveManagementComponent
    },
    {
        // merged into the Calendar page (/my-calendar)
        path: '/manager-calendars',
        redirect: '/my-calendar'
    }
]
